export default __webpack_public_path__ + "static/media/Qassim.ad10b159.mp4";